import { PromptTemplateVarInputType, PromptTemplateVar } from "../../../api"

export interface EditVarsModalContentProps {
    /**
       現在選択されている変数要素、新規作成の場合はundefined、
    */
    focusElement: PromptTemplateVar | undefined;
    /**
       作成or編集中のプロンプトテンプレートに含まれているすべての変数要素
    */
    vars: PromptTemplateVar[];
    /**
       変数要素が追加or修正されたときに呼び出す関数
    */
    onVarsChanged: (vars: PromptTemplateVar[]) => void;
    /**
       前の状態に戻りたい時に呼び出す関数
    */
    backToList: () => void
}

export interface UtilizeModalContentProps {
    templateVar: PromptTemplateVar;
}

export interface ProcessVarProps {
    templateVar: PromptTemplateVar;
    /**
       親要素のformData
       utilizeModalContentのinputのnameで値が取得できる想定
    */
    formData: FormData;
    /**
       ファイルがformDataから取得できなかったので、name===templateVar.idの<input>要素
       ファイルはここから取得する
    */
    element: HTMLInputElement;
    /**
       現在のリクエスト文（他の変数要素が処理済みかもしれない）
       主に{{templateVar.id}}となっている部分をformDataの値を使って置換する
    */
    requestPrompt: string;
    /**
       リクエスト文を修正したら呼び出す関数
    */
    onChangeRequestPrompt: (v:string) => void
    /**
       LLMに投げるファイルを追加したい時に呼び出す関数
    */
    onFileAdded: (f: File) => void
}

export interface VarElementFactory{
    /**
       対応するPromptTemplateVarInputTypeリテラル、各定義で重複は許さない
    */
    inputType: PromptTemplateVarInputType;
    /**
       この変数要素が表す概念の名前（自由入力、プルダウン等）
    */
    itemName: string;
    /**
       変数要素をリクエスト欄へD&Dできるか（今のところFileはD&Dできない）
    */
    isDroppableToRequest: boolean;
    /**
       変数要素を表すFluent UIのアイコン名
    */
    iconName: string;
    /**
       この変数要素を新規作成&編集する際に表示する要素
    */
    editVarsModalContent: (props: EditVarsModalContentProps) => JSX.Element;
    /**
       プロンプトテンプレート使用時に表示する要素
    */
    utilizeModalContent: (props: UtilizeModalContentProps) => JSX.Element;
    /**
       この変数要素の処理内容（書き起こしならファイルを書き起こして変数の場所に置換する等）
    */
    processVar: (props: ProcessVarProps) => Promise<void>
    /**
       処理中に表示するメッセージ（書き起こしなら「音声書き起こし中...」等）
    */
    processingMessage: string
}

export const defaultTextProcess = async (props: ProcessVarProps) => {
    const { formData, templateVar, requestPrompt, onChangeRequestPrompt } = props
    const data = formData.get(templateVar.id)
    const newReq = requestPrompt.replaceAll(`{{${templateVar.id}}}`, data?.toString() ?? "")
    onChangeRequestPrompt(newReq)
}

export const defaultProcessingMessage = "リクエストを処理中..."